import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function resolveArgusSurface(pathname) {
  if (pathname === '/coach/combine' || pathname.startsWith('/combine/')) return 'combine'
  if (pathname === '/coach/club-wars' || pathname.startsWith('/club-war/')) return 'club-war'
  if (pathname === '/athlete/growth') return 'growth'
  if (pathname === '/attributes') return 'intelligence'
  if (
    pathname === '/pricing' ||
    pathname === '/promotions' ||
    pathname === '/account/plan' ||
    pathname === '/account/referrals'
  ) {
    return 'commerce'
  }
  if (pathname === '/player' || pathname === '/athlete') return 'player'
  return null
}

export default function ArgusSurfaceRouteMarker() {
  const { pathname } = useLocation()

  useEffect(() => {
    const root = document.documentElement
    const surface = resolveArgusSurface(pathname)

    if (surface) root.dataset.argusSurface = surface
    else delete root.dataset.argusSurface

    return () => {
      if (root.dataset.argusSurface === surface) delete root.dataset.argusSurface
    }
  }, [pathname])

  return null
}
